import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components.
import LegendItem from './LegendItem';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Legend = ({ className, data }) =>
  <ul className={classNames('Legend', className)}>
    {data.map(({ uid, swatch, content }) =>
      <LegendItem key={uid} uid={uid} swatch={swatch}>
        {content}
      </LegendItem>,
    )}
  </ul>;

Legend.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      swatch: PropTypes.string,
      content: PropTypes.node,
    }),
  ).isRequired,
};

Legend.defaultProps = {
  className: null,
};

export default Legend;



// WEBPACK FOOTER //
// ./src/components/Chart/Legend/index.js